import React from 'react'
import cx from 'classnames'

import { TItem } from '../../types'

const CertsAndAppsAreaItem: React.FC<{
  item: TItem
  index: number
  type: 'cert' | 'app'
}> = (props) => {
  return (
    <li
      className={cx('sm:h-32 md:h-40', {
        'h-32': props.type === 'cert',
        'h-40': props.type === 'app',
        'ml-16': props.index > 0,
      })}
    >
      <a href={`${props.item.url}`}>
        <img src={props.item.image} alt={props.item.label} className="h-full" />
      </a>
    </li>
  )
}

export { CertsAndAppsAreaItem as default }
